import React, { FC, useEffect } from 'react'
import { observer } from 'mobx-react'
import { classNames, format } from '@dt/fe-utils'
import { modalLayer } from '@utils'
import { memberMobx } from '@mobxStore'
import { payPlanMobx } from '@mobx/mall/payment'
import MemberCardAmountModal from '@pages/mall/checkout/modal/MemberCardAmountModal'
import CannotPayTip from '../CannotPayTip'
import { SwitchCardModal } from '@cps'
import './index.scss'

const MemberCardPay: FC = () => {
  // 如果不可用在商城 就不可选中
  useEffect(() => {
    if (!memberMobx.mallCardInfoForPay?.card?.supportMallPay) {
      payPlanMobx.setMemberCardPayAmount(0)
    }
  }, [memberMobx.mallCardInfoForPay])
  if (!payPlanMobx.memberCardMethod) return null

  const { amount } = payPlanMobx.memberCardMethod

  const handleChangeCard = async (e: any) => {
    if (memberMobx.cardListForMall?.length > 1) {
      await modalLayer(SwitchCardModal, { type: 'mall', isPay: true }, 'switchCardModal').then((data: any) => {
        if (!amount && data?.balance > 0) {
          handleChangeAmount()
        }
      }).catch(() => { })
    }
  }

  const handleChangeAmount = async (e?: any) => {
    e?.stopPropagation()
    const amounted = await modalLayer<{ card: IMemberCardInfo; fristNum: number }, number>(MemberCardAmountModal, { card: memberMobx.mallCardInfoForPay, fristNum: payPlanMobx.totalAmount }, 'memberCardAmountModal')
    payPlanMobx.setMemberCardPayAmount(amounted)
  }

  const changeSelect = async (num, e: any) => {
    e.stopPropagation()
    if (memberMobx.mallCardInfoForPay?.balance <= 0 || !memberMobx.mallCardInfoForPay?.card?.supportMallPay) return
    if (num > 0) {
      payPlanMobx.setMemberCardPayAmount(0)
    } else {
      handleChangeAmount()
    }
  }
  return (
    <>
      <div className='mall-member-card-pay' onClick={handleChangeCard}>
        <i className='iconfont icon-yue' />
        <div className='card-info-member first'>
          <div className='card-name'>
            <span className='card-title'>
              {memberMobx.mallCardInfoForPay?.card?.cardName || i18n.t('pay.memberCard')}
            </span>
            {window.bo !== 'cn' && <CannotPayTip message={i18n.t(memberMobx.mallCardInfoForPay?.card?.isPayTip ? 'pay.memberCardGiveBalanceCannotPayTip' : 'pay.memberCardCannotPayTip')} />}
            {memberMobx.cardListForMall?.length > 1 ? <div className='triangle-tip'></div> : ''}
          </div>
          <div className='balance'>
            <span className='balance-price'>
              {i18n.t('pay.cardBalanceN', { n: format.toPrice(memberMobx.mallCardInfoForPay?.balance) })}
            </span>
            {!memberMobx.mallCardInfoForPay?.card?.supportMallPay && <span className='disable-tag'>{i18n.t('pay.memberCardGiveBalanceCannotPayMall')}</span>}
            <div className='amount-info'>
              {
                amount && amount > 0 ? (
                  <div onClick={handleChangeAmount}>
                    {format.toPrice(amount)}
                  </div>
                ) : ''
              }
            </div>
          </div>
        </div>
        <div className='amount-select' onClick={(e) => { changeSelect(amount, e) }}>
          {
            memberMobx.mallCardInfoForPay?.balance > 0 && memberMobx.mallCardInfoForPay?.card?.supportMallPay ? <i className={classNames('iconfont', (amount > 0) ? 'icon-checked' : 'no-select')} /> : <div className='no-checkout'></div>
          }
        </div>
      </div>
    </>
  )
}

export default observer(MemberCardPay)
